import { createUseStyles } from "react-jss";

export const usePageLoaderStyles = createUseStyles({
  root: {
    alignItems: "center",
    display: "flex",
    flex: 1,
    justifyContent: "center",
    width: "100%",
  },
});
